<mat-card appearance="outlined">
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Escritos</h2>
      <app-button-new
        (click)="openDialog({ accion: accionesDialog.Agregar, entidad: {idExpediente} })"></app-button-new>
    </div>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
<br>
    <form [formGroup]="formFilter">
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Titulo</mat-label>
            <input matInput type="text" maxlength="200" formControlName="Titulo" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spTipoEscrito" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Tipo</mat-label>
            <mat-select multiple placeholder="Seleccione opcion" formControlName="IdsTipoEscrito">
              <mat-option [value]="tipoEscrito.id" *ngFor="let tipoEscrito of tiposEscrito">
                {{ tipoEscrito.descripcion }}</mat-option>
            </mat-select>
            <mat-error *ngIf="formFilter.controls['IdsTipoEscrito'].hasError('required')">Este campo es
              <strong>requerido</strong>.</mat-error>
          </mat-form-field>
        </div>

        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spEstadoEscrito" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Estado</mat-label>
            <mat-select multiple placeholder="Seleccione opcion" formControlName="IdsEstadoEscrito">
              <mat-option [value]="estadoEscrito.id" *ngFor="let estadoEscrito of estadosEscrito">
                {{ estadoEscrito.descripcion }}</mat-option>
            </mat-select>
            <mat-error *ngIf="formFilter.controls['IdsEstadoEscrito'].hasError('required')">Este campo es
              <strong>requerido</strong>.</mat-error>
          </mat-form-field>
        </div>

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline">
            <mat-label>Fecha Creación</mat-label>
            <mat-date-range-input [rangePicker]="pickerFechaCreacionDesde">
              <input matStartDate formControlName="FechaCreacionDesde" placeholder="Fecha desde" />
              <input matEndDate formControlName="FechaCreacionHasta" placeholder="Fecha hasta" />
            </mat-date-range-input>
            <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="pickerFechaCreacionDesde"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerFechaCreacionDesde></mat-date-range-picker>
          </mat-form-field>
        </div>

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline">
            <mat-label>Rango de fecha</mat-label>
            <mat-date-range-input [rangePicker]="pickerFechaAltaDesde">
              <input matStartDate formControlName="FechaAltaDesde" placeholder="Fecha desde" />
              <input matEndDate formControlName="FechaAltaHasta" placeholder="Fecha hasta" />
            </mat-date-range-input>
            <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="pickerFechaAltaDesde"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerFechaAltaDesde></mat-date-range-picker>
          </mat-form-field>
        </div>


        <div class="col" *ngIf="checkedFiltroAvanzado">
          <app-select-usuarios-empresa [label]="'Creado por'"
            (usuarioSeleccionado)="onCreadoPorSeleccionado($event)"></app-select-usuarios-empresa>
        </div>

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <app-select-usuarios-empresa [label]="'Modificado por'"
            (usuarioSeleccionado)="onAprobadoPorSeleccionado($event)"></app-select-usuarios-empresa>
        </div>

         <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Cuerpo Escrito</mat-label>
            <input matInput type="text"  formControlName="CuerpoHTML" />
          </mat-form-field>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-auto">
          <div style="display: flex; align-items: center; gap: 8px;">
            <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
            <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
          </div>

        </div>
        <div class="col-auto">
          <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>
        </div>
      </div>
    </form>
    </div>
  </mat-card-content>

  <mat-card-content>
    <mat-divider></mat-divider>
    <ngx-spinner [zIndex]="100" name="spListado" bdColor="rgba(255,255,255,0.8)" size="default"
      color="var(--primary-color)" type="ball-atom" [fullScreen]="false"></ngx-spinner>

    <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Boton de Acciones -->
      </div>
      <mat-form-field appearance="outline" *ngIf="esVistaTabla && data" class="buscador-tabla">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input />
      </mat-form-field>
    </div>
    <!-- Fin Contenedor acciones tabla -->


    <div>
       <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" *ngIf="data" matSort matSortStart="asc">
          <ng-container matColumnDef="titulo">
            <mat-header-cell *matHeaderCellDef mat-sort-header><strong>Título</strong></mat-header-cell>
            <mat-cell *matCellDef="let item"><span>{{ item.titulo | titlecase }}</span></mat-cell>
          </ng-container>

          <ng-container matColumnDef="tipoEscrito">
            <mat-header-cell *matHeaderCellDef mat-sort-header><strong>Tipo</strong></mat-header-cell>
            <mat-cell *matCellDef="let item"><span>{{ item.tipoEscrito?.descripcion | titlecase }}</span></mat-cell>
          </ng-container>

          <ng-container matColumnDef="fechaCreacion">
            <mat-header-cell *matHeaderCellDef mat-sort-header><strong>Fecha creación</strong></mat-header-cell>
            <mat-cell *matCellDef="let item"><span>{{ item.fechaCreacion | date: "short" }}</span></mat-cell>
          </ng-container>


          <ng-container matColumnDef="estadoEscrito">
            <mat-header-cell *matHeaderCellDef mat-sort-header><strong>Estado</strong></mat-header-cell>
            <mat-cell *matCellDef="let item">
              {{item.estadoEscrito?.descripcion | titlecase}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="creadoPor">
            <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Creado por</strong>
            </mat-header-cell>
            <mat-cell *matCellDef="let item">
              <app-avatar-iniciales [size]="'sm'" [nombre]='item.creadoPor?.nombre'
                [apellido]='item.creadoPor?.apellido' [activo]='item.creadoPor?.activo'></app-avatar-iniciales>

            </mat-cell>
          </ng-container>

          <!-- Accion Column -->
          <ng-container matColumnDef="accion">
            <mat-header-cell mat-header-cell *matHeaderCellDef>
              <strong>Acción</strong>
            </mat-header-cell>
            <mat-cell *matCellDef="let item" class="action-link">
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu" >
                <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Ver, entidad: {item} })">
                  <mat-icon>visibility</mat-icon>
                  <span>Ver</span>
                </button>
                <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Modificar, entidad: {item} })">
                  <mat-icon>edit</mat-icon>
                  <span>Editar</span>
                </button>
                <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: {item} })"
                  >
                  <mat-icon>delete</mat-icon>
                  <span>Eliminar</span>
                </button>
              </mat-menu>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
        </table>

        <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>

        <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="5"
          [pageSizeOptions]="[5, 10, 20, 50, 100, 200]"></mat-paginator>
    </div>
  </mat-card-content>

</mat-card>
